import * as React from "react"
import { HugeiconsIcon } from "@hugeicons/react"
import * as HugeiconsCore from "@hugeicons/core-free-icons"

export interface IconPlaceholderProps extends Omit<React.ComponentProps<typeof HugeiconsIcon>, 'icon'> {
  hugeicons: keyof typeof HugeiconsCore
}

export function IconPlaceholder({ hugeicons, ...props }: IconPlaceholderProps) {
  const IconComponent = HugeiconsCore[hugeicons]
  if (!IconComponent) {
    console.warn(`Icon ${hugeicons} not found in @hugeicons/core-free-icons`)
    return null
  }
  return <HugeiconsIcon icon={IconComponent} {...props} />
}

